<div class="row col-md-12">
  <div class="col-md-4 d-inline-block pb-2" style="height: 40px;">
    <ng-select [items]="chartTypeList" bindLabel="name" [clearable]="false" [addTag]="false" [multiple]="false"
      placeholder="Select Type" (change)="changeValue('chart',chart_type.value)" [(ngModel)]="chart_type">
    </ng-select>
  </div>
  <div class="col-md-8 text-right d-inline-block btn-group btn-group-toggle" data-toggle="buttons">
    <label class="btn btn-outline-primary" [ngClass]="{'active':freq_type === 'Day'}"
      (click)="changeValue('frequency',$event.target.innerText)">
      <input type="radio" name="options" id="option1" [(ngModel)]="freq_type" autocomplete="off" value="Day" checked>Day
    </label>
    <label class="btn btn-outline-primary" [ngClass]="{'active':freq_type === 'Week'}"
      (click)="changeValue('frequency',$event.target.innerText)">
      <input type="radio" name="options" id="option2" autocomplete="off" [(ngModel)]="freq_type" value="Week">Week
    </label>
    <label class="btn btn-outline-primary" [ngClass]="{'active':freq_type === 'Month'}"
      (click)="changeValue('frequency',$event.target.innerText)">
      <input type="radio" name="options" id="option3" autocomplete="off" [(ngModel)]="freq_type" value="Month">Month
    </label>
    <label class="btn btn-outline-primary" [ngClass]="{'active':freq_type === 'Year'}"
      (click)="changeValue('frequency',$event.target.innerText)">
      <input type="radio" name="options" id="option4" autocomplete="off" [(ngModel)]="freq_type" value="Year">Year
    </label>
  </div>
</div>
<div style="display: block;">
  <canvas baseChart width="400" height="130" [datasets]="lineChartData" [labels]="lineChartLabels"
    [options]="lineChartOptions" [colors]="lineChartColors" [legend]="lineChartLegend" [chartType]="lineChartType"
    [plugins]="lineChartPlugins" (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)"></canvas>
</div>
